import React, { useEffect, useRef, useState } from 'react';
import "./styleUser.css";
import INCSUBSearchbar from '../../components/common/SearchBar/INCSUBSearchbar';
import INCSUBUserDetails from './userprofile/UserDetails';
import { useDispatch, useSelector } from 'react-redux';
import { setRouteStatus } from '../../redux/commonSlice';
import { setSelectedUser, setUserCountData, setUserList, setUserRoutePath, setUsrDetailsRoute } from '../../features/users/userSlice';
import { getUserList, getUserCounts } from '../../services/userServices';
import { toast } from 'react-toastify';
import { data, useNavigate } from 'react-router';
import ReactPaginate from 'react-paginate';

function INCSUBuser() {

    const userList = useSelector((state)=>state.user.userList)
    const [keyValue, setKeyValue] = useState('')
    const [responseData, setResponseData] = useState(null)
    const [userId, setUserId] = useState(null)
    // const [userCountData, setUserCountData] = useState(null);
    const userCountData = useSelector((state) => state.user.userCountData);
    const navigate = useNavigate();
    const userRoutePath = useSelector((state) => state.user.userRoutePath)
    const [userListByType, setUserListByType] = useState(localStorage.getItem('userType') || 'All');
    const [userListByStatus, setUserListByStatus] = useState(localStorage.getItem('userStatus') || 'All');
    const selectedUser = useSelector((state) => state.user.selectedUser);
    const [listApiFlag, setListApiFlag] = useState(false)
    const [countApiFlag, setCountApiFlag] = useState(false);
    const [shimmer, setShimmer] = useState(false);

    useEffect(() => {
        localStorage.setItem('userType', 'All');
        localStorage.setItem('userStatus', 'All');
        setUserListByType(localStorage.getItem('userType') || 'All');
        setUserListByStatus(localStorage.getItem('userStatus') || 'All');
    }, []);

    // Function to search users
    async function searchUser(key) {
        setKeyValue(key);
        setListApiFlag(true);
        try {
            const response = await getUserList(
                key,
                localStorage.getItem('userType'),
                localStorage.getItem('userStatus'),
                0,
                30
            );

            if (response?.request?.status === 200) {
                setListApiFlag(false)
                setResponseData(response);
                dispatch(setUserList(response?.data?.data?.userDetail));
            } else if (response?.status === 401) {
                setRouteStatus('/login');
                navigate('/login');
            }
            else {
                setListApiFlag(false)
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        }

    }

    // Function to update user type
    const handleUserTypeChange = (type) => {
        localStorage.setItem('userType', type);
        localStorage.setItem('userType', type);
        setUserListByType(type);
    };
    const handleUserStatusChange = (status) => {
        localStorage.setItem('userStatus', status);
        localStorage.setItem('userStatus', status);
        setUserListByStatus(status);
    };

    const userTypeArr = [
        'All',
        'User',
        'Host',
        'User+Host'
    ]

    const userStatusArr = [
        'All',
        'Active',
        'Inactive',
        'Suspend'
    ]


    const [isOpenType, setIsOpenType] = useState(false);
    const [isOpenStatus, setIsOpenStatus] = useState(false);
    const refType = useRef(null);
    const refStatus = useRef(null);
    const routeStatus = useSelector((state) => state.common.routeStatus);
    const dispatch = useDispatch();
    const [pageNo, setPageNo] = useState(0);
    const [pageCount, setPageCount] = useState(0)

    const fetchUserDetailsData = async (pageNo) => {
        const response = await getUserList(keyValue, userListByType, userListByStatus, pageNo, 30);
        if (response?.request?.status === 200) {
            setListApiFlag(false)
            setResponseData(response)
            dispatch(setUserList(response?.data?.data?.userDetail))
            setPageCount(response?.data?.data.totalPages)

        } else {
            setListApiFlag(false)
        }
    };

    const fetchCountData = async () => {
        const response = await getUserCounts();
        if (response?.request?.status === 200) {
            dispatch(setUserCountData(response?.data?.data))
            setCountApiFlag(false)

        } else {
            setCountApiFlag(false)
        }
    };
    //@getUserlist function call
    useEffect(() => {
        setResponseData(null)
        setListApiFlag(true)
        fetchUserDetailsData(pageNo)
        if (userCountData === null) {
            fetchCountData()
            setCountApiFlag(true)
        }

    }, [userListByType, userListByStatus]);

    /* @Author Vishal
        Created on 2025-02005
        function Name : convertDateFormat
        parameters : 2025-01-09T18:51:36
        output : January 9, 2025
    */
    const convertDateFormat = (date) => {
        const dateObj = new Date(date);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = dateObj.toLocaleDateString('en-US', options);
        return formattedDate;
    }


    const handleClickOutside = (event) => {
        if (refType.current && !refType.current.contains(event.target)) {
            setIsOpenType(false);
        }
        if (refStatus.current && !refStatus.current.contains(event.target)) {
            setIsOpenStatus(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleUserCount = (prevtype, type, count) => {
        if (type === 'suspend') {

        }
    }


    const [currentPage, setCurrentPage] = useState(0);

    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);
        const endOffset = itemOffset;

        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            fetchUserDetailsData(event.selected)
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBComplaints_list_section_container'>{
                !shimmer && userList && userList.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }
            </div>
        );
    }

    return (
        <div className='INCSUBuser'>{
            routeStatus === '/user' && userRoutePath === "/user" ?
                <div className='INCSUBuser_container'>
                    <div className='INCSUBUser_filter_section'>
                        <div className="INCSUBPools_Search_filters_container">
                            <INCSUBSearchbar width={500} height={38} placeholder={'Search'} source={"user"} searchFunction={searchUser} />
                            <div className='INCSUBuser_type_filter'>
                                <div className='INCSUBuser_type_filter_input' onClick={() => setIsOpenType(!isOpenType)}>{userListByType}{userListByType === 'All' ? <span>(By User Type)</span> : null}<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.3126 5.54697C5.17753 5.68199 4.99437 5.75784 4.8034 5.75784C4.61242 5.75784 4.42926 5.68199 4.2942 5.54697L0.219877 1.47265C0.151088 1.40621 0.0962192 1.32674 0.0584729 1.23887C0.0207266 1.151 0.000858202 1.05649 2.71931e-05 0.96086C-0.000803816 0.865229 0.0174193 0.77039 0.0536329 0.681876C0.0898466 0.593363 0.143326 0.512948 0.21095 0.445324C0.278574 0.3777 0.358988 0.324221 0.447501 0.288008C0.536014 0.251794 0.630854 0.233571 0.726485 0.234402C0.822116 0.235233 0.916624 0.255102 1.00449 0.292848C1.09236 0.330594 1.17184 0.385462 1.23828 0.454251L4.8034 4.01937L8.36852 0.454251C8.50435 0.323056 8.68628 0.250462 8.87512 0.252103C9.06396 0.253744 9.24461 0.329489 9.37814 0.463025C9.51168 0.59656 9.58742 0.777202 9.58907 0.966043C9.59071 1.15488 9.51811 1.33682 9.38692 1.47265L5.3126 5.54697Z" fill="black" />
                                </svg>
                                </div>{
                                    isOpenType ? <div ref={refType} className='INCSUBuser_type_filter_list'>
                                        <ul>
                                            {userTypeArr && userTypeArr?.length > 0 && userTypeArr?.map((str) => (
                                                <li onClick={() => {
                                                    handleUserTypeChange(str)
                                                    setIsOpenType(false)
                                                }}>{str}</li>
                                            ))}
                                        </ul>
                                    </div> : null
                                }
                            </div>
                            <div className='INCSUBuser_type_filter'>
                                <div className='INCSUBuser_type_filter_input' onClick={() => setIsOpenStatus(!isOpenStatus)}>{userListByStatus} {userListByStatus === 'All' ? <span>(By Status)</span> : null}<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.3126 5.54697C5.17753 5.68199 4.99437 5.75784 4.8034 5.75784C4.61242 5.75784 4.42926 5.68199 4.2942 5.54697L0.219877 1.47265C0.151088 1.40621 0.0962192 1.32674 0.0584729 1.23887C0.0207266 1.151 0.000858202 1.05649 2.71931e-05 0.96086C-0.000803816 0.865229 0.0174193 0.77039 0.0536329 0.681876C0.0898466 0.593363 0.143326 0.512948 0.21095 0.445324C0.278574 0.3777 0.358988 0.324221 0.447501 0.288008C0.536014 0.251794 0.630854 0.233571 0.726485 0.234402C0.822116 0.235233 0.916624 0.255102 1.00449 0.292848C1.09236 0.330594 1.17184 0.385462 1.23828 0.454251L4.8034 4.01937L8.36852 0.454251C8.50435 0.323056 8.68628 0.250462 8.87512 0.252103C9.06396 0.253744 9.24461 0.329489 9.37814 0.463025C9.51168 0.59656 9.58742 0.777202 9.58907 0.966043C9.59071 1.15488 9.51811 1.33682 9.38692 1.47265L5.3126 5.54697Z" fill="black" />
                                </svg>
                                </div>{
                                    isOpenStatus ? <div ref={refStatus} className='INCSUBuser_type_filter_list'>
                                        <ul>
                                            {userStatusArr && userStatusArr?.length > 0 && userStatusArr?.map((str) => (
                                                <li onClick={() => {
                                                    handleUserStatusChange(str)
                                                    setIsOpenStatus(false)
                                                }}>{str}</li>
                                            ))}
                                        </ul>
                                    </div> : null
                                }

                            </div>
                        </div>
                    </div>
                    <div className='INCSUBUser_overview_section'>
                        <div className='INCSUBusercount_container'>
                            <div className='INCSUBusercount_status'>
                                <div className='INCSUBusercount_status_name'>Total Users</div>
                                {countApiFlag === false ? <div className='INCSUBusercount_status_count'>{userCountData?.totalUsers}</div> :
                                    <div className='HeadLoaderDiv'>
                                        <span className="loaderHead"></span>
                                    </div>
                                }
                            </div>
                            <div className='INCSUBusercount_status_icon'>
                                <img src='/assets/icons/user/totalusericon.svg' alt='usericon' />
                            </div>
                        </div>
                        <div className='INCSUBusercount_container'>
                            <div className='INCSUBusercount_status'>
                                <div className='INCSUBusercount_status_name'>Active User</div>
                                {countApiFlag === false ? <div className='INCSUBusercount_status_count'>{userCountData?.activeUsers}</div> :
                                    <div className='HeadLoaderDiv'>
                                        <span className="loaderHead"></span>
                                    </div>
                                }
                            </div>
                            <div className='INCSUBusercount_status_icon'>
                                <img src='/assets/icons/user/totalusericon.svg' alt='usericon' />
                            </div>
                        </div>
                        <div className='INCSUBusercount_container'>
                            <div className='INCSUBusercount_status'>
                                <div className='INCSUBusercount_status_name'>Inactive User</div>
                                {countApiFlag === false ? <div className='INCSUBusercount_status_count'>{userCountData?.inactiveUser}</div> :
                                    <div className='HeadLoaderDiv'>
                                        <span className="loaderHead"></span>
                                    </div>
                                }
                            </div>
                            <div className='INCSUBusercount_status_icon'>
                                <img src='/assets/icons/user/totalusericon.svg' alt='usericon' />
                            </div>
                        </div>
                        <div className='INCSUBusercount_container'>
                            <div className='INCSUBusercount_status'>
                                <div className='INCSUBusercount_status_name'>Suspended</div>
                                {countApiFlag === false ? <div className='INCSUBusercount_status_count'>{userCountData?.suspendedUser}</div> :
                                    <div className='HeadLoaderDiv'>
                                        <span className="loaderHead"></span>
                                    </div>
                                }

                            </div>
                            <div className='INCSUBusercount_status_icon'>
                                <img src='/assets/icons/user/totalusericon.svg' alt='usericon' />
                            </div>
                        </div>

                    </div>
                    <div className='INCSUBUser_userlist_section'>
                        <div className='INCSUBUser_userlist_section_table_conatiner'>
                            <table className='INCSUBuser_table'>
                                <thead className='INCSUBuser_table_head'>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Mail ID</th>
                                        <th>Join Date</th>
                                        <th>User Type</th>
                                        <th>Earning</th>
                                        <th>KYC Status</th>
                                        <th>Platforms</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                {listApiFlag === false ? (
                                    userList && userList.length > 0 ? (
                                        <tbody className='INCSUBuser_table_body'>
                                            {userList && userList.length > 0 &&
                                                userList.map((obj, index) => (
                                                    <tr
                                                        key={index}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            // fetchPersonalDetails(obj?.userId);
                                                            dispatch(setSelectedUser(obj))
                                                            dispatch(setUsrDetailsRoute('/personaldetails'));
                                                            dispatch(setUserRoutePath('/userdetails'))

                                                        }}
                                                    >
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <div className='INCSUBprofile_name_container'>
                                                                <div className='INCSUBProfile_image_holder'>
                                                                    <img src={obj?.userImage ? obj?.userImage : '/assets/icons/common/defaultImage.png'} alt='profile' />
                                                                </div>
                                                                <div className='name_container'>
                                                                    <div className='name'>{obj?.userFullName}</div>
                                                                    <div className='mobile_no'>+91{obj?.userMobileNumber}</div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>{obj?.userEmail}</td>
                                                        <td>{convertDateFormat(obj?.createdAt)}</td>
                                                        <td>{obj?.userRole!=="User"?obj?.userRole:obj?.userType}
                                                        </td>
                                                        <td>{obj?.earning ? `₹${obj?.earning}` : '-'}</td>
                                                        <td>
                                                            <span
                                                                className="status verified user_type"
                                                                style={{
                                                                    background: obj?.kycStatus ? 'rgba(204, 240, 235, 1)' : 'rgba(255, 235, 204, 1)',
                                                                    color: obj?.kycStatus ? 'rgba(0, 182, 155, 1)' : 'rgba(255, 157, 0, 1)'
                                                                }}
                                                            >
                                                                {obj?.kycStatus ? 'Verified' : 'Pending'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div className='INCSUBuser_platform_name'>{obj?.platforms[0]}</div>
                                                            {obj?.platforms.length > 1 && (
                                                                <div
                                                                    className='INCSUBuser_platform_viewmore'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        dispatch(setSelectedUser(obj))
                                                                        dispatch(setUsrDetailsRoute("/platformandpools"));
                                                                        dispatch(setUserRoutePath('/userdetails'))

                                                                    }}
                                                                >
                                                                    View More
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <span
                                                                className={`status ${obj?.status}`}
                                                            >
                                                                {obj?.status}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )
                                                )}
                                        </tbody>
                                    ) : (
                                        <div className='NoDataFoundDiv'>No Data Found</div>
                                    )
                                ) : (
                                    <div className='loaderBodyDiv'>
                                        <span className='loaderBody'>Loading</span>
                                    </div>
                                )}

                            </table>

                        </div>
                    </div>
                    {<PaginatedItems />}
                </div> : <INCSUBUserDetails user={selectedUser} func={handleUserCount()} />}

        </div>
    )
}

export default INCSUBuser
